// Libs
import React from 'react';
import { format } from 'date-fns';
import { Typography, Box } from '@mui/material';

const formatOrderDate = (date) =>
  date ? format(new Date(date), 'MM/dd/yyyy') : '-';

const OrderInfoFields = ({
  orderId,
  orderDate,
  shipDate,
  address,
  shippedToText,
  classes,
}) => (
  <>
    <Typography variant="h3" mt={2} mb={1} className={classes.blockHeader}>
      Order Details
    </Typography>
    <Box display="flex">
      <Typography className={classes.productInfoHeader}>
        Order ID:&nbsp;
      </Typography>
      <Typography className={classes.productInfoText}>{orderId}</Typography>
    </Box>
    <Box display="flex">
      <Typography className={classes.productInfoHeader}>
        Order Date:&nbsp;
      </Typography>
      <Typography className={classes.productInfoText}>
        {formatOrderDate(orderDate)}
      </Typography>
    </Box>
    <Box display="flex">
      <Typography className={classes.productInfoHeader}>
        Ship Date:&nbsp;
      </Typography>
      <Typography className={classes.productInfoText}>
        {formatOrderDate(shipDate)}
      </Typography>
    </Box>
    {address && (
      <Box display="flex">
        <Typography className={classes.productInfoText}>
          <b>Shipped To:</b> {shippedToText}
        </Typography>
      </Box>
    )}
  </>
);

export default OrderInfoFields;
